import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import DashboardHeader from "@/components/DashboardHeader";
import UpdatedTermsModal from "@/components/UpdatedTermsModal";
import { useAuth } from "@/hooks/useAuth";

const CURRENT_TERMS_VERSION = "2.0";

export default function DashboardShell({ children }) {
  const { user, signOut } = useAuth();
  const [showTermsModal, setShowTermsModal] = useState(false);
  const isImpersonating = typeof window !== "undefined" && localStorage.getItem("vouchee_impersonating") === "true";

  const returnToAdmin = () => {
    const adminToken = localStorage.getItem("vouchee_auth_token_backup");
    if (adminToken) {
      localStorage.setItem("vouchee_auth_token", adminToken);
      localStorage.removeItem("vouchee_impersonating");
      localStorage.removeItem("vouchee_auth_token_backup");
      window.location.href = "/admin";
    }
  };

  useEffect(() => {
    if (!user) return;
    const acceptedVersion = localStorage.getItem("vouchee_accepted_terms_version");
    if (acceptedVersion !== CURRENT_TERMS_VERSION) {
      setShowTermsModal(true);
    }
  }, [user]);

  return (
    <div className="min-h-screen bg-gray-50">
      {isImpersonating && (
        <div className="bg-indigo-600 text-white text-center py-2 px-4 text-sm flex items-center justify-center gap-3 sticky top-0 z-50">
          <span>Impersonating: <strong>{user?.full_name || user?.email || "user"}</strong></span>
          <button
            onClick={returnToAdmin}
            className="bg-white text-indigo-600 px-3 py-1 rounded-full text-xs font-bold hover:bg-indigo-100"
          >
            Return to Admin
          </button>
        </div>
      )}
      <DashboardHeader />
      <main className="py-8">{children ?? <Outlet />}</main>

      {showTermsModal && (
        <UpdatedTermsModal
          documents={[
            {
              type: "terms",
              title: "Terms of Service",
              version: CURRENT_TERMS_VERSION,
              effectiveDate: "2026-03-01",
              changes: ["Updated commission policies", "Added data processing terms"],
              url: "/terms",
            },
            {
              type: "privacy",
              title: "Privacy Policy",
              version: CURRENT_TERMS_VERSION,
              effectiveDate: "2026-03-01",
              changes: ["Updated data retention policy"],
              url: "/privacy",
            },
          ]}
          onAccept={() => {
            localStorage.setItem("vouchee_accepted_terms_version", CURRENT_TERMS_VERSION);
            setShowTermsModal(false);
          }}
          onDecline={() => {
            signOut();
            setShowTermsModal(false);
          }}
        />
      )}
    </div>
  );
}
